/**
 * fileStorage.ts
 *
 * All application records are stored directly in the MariaDB database via Prisma,
 * per Captain's directive ("semua data harus disimpan di database tidak ada di file json").
 * File-based JSON persistence has been completely retired.
 */

export function loadPersistentData<T>(_fileName: string, defaultData: T): T {
  // All persistence is loaded directly from MariaDB tables via dbBridge
  return defaultData;
}

export function savePersistentData<T>(_fileName: string, _data: T): void {
  // No-op: all operational mutations are written directly to MariaDB tables via dbBridge
}
